class CartRecommendations extends HTMLElement {
  #mutationObserver = null;
  #initCarouselTimeout = null;

  constructor() {
    super();
  }

  connectedCallback() {
    this.observeMutations();
    this.loadRecommendations();
    this.initializeCarousel();
  }

  disconnectedCallback() {
    clearTimeout(this.#initCarouselTimeout);
    this.#mutationObserver?.disconnect();
    this.#mutationObserver = null;
  }

  observeMutations() {
    this.#mutationObserver = new MutationObserver((mutations) => {
      const hasChildListChange = mutations.some(
        (m) =>
          m.type === 'childList' &&
          (m.addedNodes.length > 0 || m.removedNodes.length > 0),
      );
      if (hasChildListChange) {
        clearTimeout(this.#initCarouselTimeout);
        this.#initCarouselTimeout = setTimeout(
          () => this.initializeCarousel(),
          0,
        );
      }
    });

    this.#mutationObserver.observe(this, {
      childList: true,
      subtree: true,
    });
  }

  loadRecommendations() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(this);

      const url = this.dataset.url;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.cart-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: '0px 0px 200px 0px',
    });

    observer.observe(this);
  }

  initializeCarousel() {
    const emblaNode = document.querySelector('.embla');
    if (!emblaNode) {
      return false;
    }

    const slides = emblaNode.querySelectorAll('.embla__slide');
    if (slides.length === 0) {
      return false;
    }

    const emblaOptions = { loop: true, align: 'start' };

    const viewportNode = emblaNode.querySelector('.embla__viewport');
    const prevBtnNode = emblaNode.querySelector('.embla__button--prev');
    const nextBtnNode = emblaNode.querySelector('.embla__button--next');
    const emblaApi = EmblaCarousel(viewportNode, emblaOptions);

    prevBtnNode.addEventListener('click', () => emblaApi.scrollPrev(), false);
    nextBtnNode.addEventListener('click', () => emblaApi.scrollNext(), false);
  }
}

customElements.define('cart-recommendations', CartRecommendations);
